import { Controller } from "@hotwired/stimulus"

// Submits the controller's own <form> when an action fires (typically a file
// input's `change`), so a single-field form persists without an explicit Save
// button. Pairs with a Turbo Stream response that swaps the affected fragment.
//
// Usage:
//   form[data-controller="auto-submit"]
//     input[type=file][data-action="change->auto-submit#submit"]
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
